import Handlebars from "handlebars";

import functionList from "./function_list";

export default function register() {
  Handlebars.registerHelper(functionList);
}
